import { Form } from "@redriver/cinnamon-mui";
import { internalUsersLookup } from "modules/lookups";

const InternalUserTypeAhead = (props) => (
  <Form.TypeAhead lookup={internalUsersLookup} {...props} />
);

export default InternalUserTypeAhead;
